import {Button} from 'antd';
import {ButtonType} from 'antd/es/button';
import React, {FC} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {IMetaActionInfo} from 'entities/metadata';
import {useAppDispatch} from 'store/config/hooks';
import {requestSliceActions} from 'store/slices/request-slice/request-slice';

interface IButtonSaveOwnProps {
    actionTitle: string;
    actionType?: IMetaActionInfo['actionType'];
    actionIcon?: TIconType;
    buttonType: ButtonType;
}

interface IButtonSaveProps extends IButtonSaveOwnProps {}

export const ButtonSave: FC<IButtonSaveProps> = ({
    actionTitle,
    actionType,
    actionIcon,
    buttonType,
    ...props
}: IButtonSaveProps) => {
    const dispatch = useAppDispatch();
    const {setSubmitButtonActionType} = requestSliceActions;

    const handleClick = () => {
        if (actionType) dispatch(setSubmitButtonActionType(actionType));
    };

    return (
        <Button
            {...props}
            type={buttonType}
            className="save-action-btn"
            htmlType="submit"
            onClick={handleClick}
        >
            {actionIcon && <DynamicIcon type={actionIcon} />}
            {actionTitle}
        </Button>
    );
};
